import { createFileRoute } from '@tanstack/react-router'

import { WithdrawalSMZResult } from '@/pages/withdrawal-smz-result'

export const Route = createFileRoute('/_protected/withdrawal-smz/result/')({
    component: WithdrawalSMZResult,
})
